import { Injectable, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from "@angular/core";

import { ModalDialogComponent } from "./modaldialog.component";

@Injectable()
export class ModalDialogService {
  viewContainerRef: ViewContainerRef;
  modalRefList: ComponentRef<ModalDialogComponent>[];

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    this.modalRefList = [];
  }

  setViewContainer(viewContainerRef: ViewContainerRef) {
    this.viewContainerRef = viewContainerRef;
  }

  createModal(viewContainerRef?: ViewContainerRef): ModalDialogComponent {
    const factory = this.componentFactoryResolver.resolveComponentFactory(ModalDialogComponent);
    const vcref = viewContainerRef ? viewContainerRef : this.viewContainerRef;
    const modalRef = vcref.createComponent(factory);
    this.modalRefList.push(modalRef);
    return modalRef.instance;
  }

  dismissModal(modal: ModalDialogComponent) {
    for (let i = 0; i < this.modalRefList.length; i++) {
      if (this.modalRefList[i].instance == modal) {
        this.modalRefList[i].destroy();
        this.modalRefList.splice(i, 1);
        break;
      }
    }
  }

  dismissAllModals() {
    for (let i = 0; i < this.modalRefList.length; i++) {
      this.modalRefList[i].destroy();
    }
    this.modalRefList = [];
  }

  showAlert(title: string, body: string, callback?: () => void) {
    const modal = this.createModal();
    modal.showAlert(title, body).subscribe({
      next: button => {
        modal.close();
        if (callback) {
          callback();
        }
      },
      complete: () => this.dismissModal(modal),
    });
  }

  showConfirmation(title: string, body: string, callbackYes: () => void, callbackNo?: () => void) {
    const modal = this.createModal();
    modal.showConfirmation(title, body).subscribe({
      next: button => {
        modal.close();
        if (button.index == 0) {
          if (callbackNo) {
            callbackNo();
          }
        } else if (button.index == 1) {
          callbackYes();
        }
      },
      complete: () => this.dismissModal(modal),
    });
  }
}
